import script from "./BackTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackTop.vue?vue&type=script&setup=true&lang=ts"

import "./BackTop.vue?vue&type=style&index=0&id=7f82e808&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f82e808"]])

export default __exports__